export { default } from './WrapperLightBox';
